// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__aM8Nq","wrapOverlay":"styles_wrapOverlay__3j0+T","spinner":"styles_spinner__7psYV","spin":"styles_spin__ttwZc","label":"styles_label__DpPvg"};